var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"default-avatar"},[_c('figure',[_c('img',{staticClass:"rounded-circle",attrs:{"src":_vm.currentAvatar,"alt":"avatar"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }